import { computed, makeObservable } from 'mobx';
import { SelectInputComponent, SelectInputState } from '../../components/input/input.select';
import { IMithrilStateComponent } from '../../components/mithril.component';
import { Spinner } from '../../components/spinner/spinner';
import { T } from '../../i18n';
import type { MithrilVNode } from '../../mithril';
import { OrgDepartmentSelectorCtrl } from './org.department.selector.ctrl';

interface OrgDepartmentSelectorOptions {
	crossOrganization: boolean;
}

export class OrgDepartmentSelector extends IMithrilStateComponent {
	ctrl: OrgDepartmentSelectorCtrl;
	inputState: SelectInputState;

	constructor(selectorOptions: OrgDepartmentSelectorOptions = { crossOrganization: false }) {
		super();

		makeObservable(this);

		this.ctrl = new OrgDepartmentSelectorCtrl(selectorOptions.crossOrganization);
		const options = this.ctrl.departmentOptions;
		this.inputState = new SelectInputState(T.DEPARTMENT, options);
		this.inputState.isRequired = true;

		// If the input value changes, update selected department.
		this.reaction(
			() => this.inputState.value,
			(departmentId) => {
				if (!departmentId) {
					return;
				}
				this.ctrl.selectDepartment(departmentId);
			},
			{ fireImmediately: true }
		);
	}

	get nodes(): MithrilVNode {
		if (this.inputState == null) {
			return null;
		}

		if (this.ctrl.loadingDepartments) {
			return Spinner.view();
		}

		return SelectInputComponent.view(this.inputState);
	}

	@computed get selectedDepartmentId(): string {
		return this.ctrl.selectedDepartmentId;
	}
}
